import React from 'react';
import {Navigate } from 'react-router-dom';

const PrivateRoute = ({children }) => {
  if(getAuth()) return children // Check to see if user is logged in

  return <Navigate to="/login" replace />; // Reject and return user to login page if login check fails
};

const getAuth = () => {
  if (sessionStorage.getItem('LOGGED_IN')) {
    return true;
  }

  return false;
};

export default PrivateRoute;